import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/home/img_home_top_bg.jpg'
import _imports_1 from '@/assets/home/img_home_top_bg_phone.jpg'


const _withScopeId = n => (_pushScopeId("data-v-22c348be"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "home-root"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "home_bg_img hidden-md-and-down"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "home_bg_img hidden-md-and-up"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-100 hidden-md-and-down" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-50 hidden-md-and-up" }, null, -1))

import {AppConfig} from "@/config";
import HomeCredit from "@/views/home/HomeCredit.vue";
import HomeCreditPhone from "@/views/home/HomeCreditPhone.vue";
import HomeProgress from "@/views/home/HomeProgress.vue";
import HomeWhyMe from "@/views/home/HomeWhyMe.vue";
import HomeContact from "@/views/home/HomeContact.vue";
import HomeProgressPhone from "@/views/home/HomeProgressPhone.vue";
import HomeWhyMePhone from "@/views/home/HomeWhyMePhone.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_unref(AppConfig).isPro)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createVNode(HomeCredit),
        _createVNode(HomeCreditPhone),
        _createVNode(HomeWhyMe),
        _createVNode(HomeWhyMePhone),
        _createVNode(HomeProgress),
        _createVNode(HomeProgressPhone),
        _createVNode(HomeContact)
      ]))
    : _createCommentVNode("", true)
}
}

})